<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Edit tags')"
    :loading="loading"
    icon="tags"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      return this.bcDocumentStore.edit || this.$route.matched[0].name === 'BCFile'
    },
    isActive() {
      if (this.$route.matched[0].name === 'BCFile') {
        return true
      }

      for (let idx = 0; idx < this.bcSelectedStore.listFullySelected.length; idx++) {
        const item = this.bcSelectedStore.listFullySelected[idx]
        if ((item.type === 'file' && item.file)) {
          return true
        }
      }

      return false
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    click() {
      this.$store.commit('nette/updateControl', {
        controlName: 'editFilesTagsForm',
        data: true,
        key: 'showModal',
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
